import type { HTMLAttributes } from 'react';

interface OptimizedImageProps extends Omit<HTMLAttributes<HTMLImageElement>, 'src'> {
  name: string;
  widths: number[];
  alt: string;
  /**
   * Loading strategy:
   * - 'lazy': Delays loading until image is near viewport
   * - 'eager': Loads immediately
   */
  loading?: 'lazy' | 'eager';
  className?: string;
}

export function OptimizedImage({ name, widths, alt, loading = 'lazy', className, ...props }: OptimizedImageProps) {
  const webpSrcSet = widths.map(w => `/optimized/${name}-${w}w.webp ${w}w`).join(', ');
  const pngSrcSet = widths.map(w => `/optimized/${name}-${w}w.png ${w}w`).join(', ');
  const fallbackSrc = `/optimized/${name}-${widths[widths.length - 1]}w.png`;

  return (
    <picture>
      <source type="image/webp" srcSet={webpSrcSet} />
      <source type="image/png" srcSet={pngSrcSet} />
      <img src={fallbackSrc} alt={alt} loading={loading} className={className} {...props} />
    </picture>
  );
}
